import {Context, createContext} from 'solid-js'
import {ConvivaProviderBehavior} from './ConvivaProvider'
import {ConvivaMetadata, Constants as ConvivaConstants} from '@convivainc/conviva-js-coresdk'

const initialConvivaProviderBehavior: ConvivaProviderBehavior = {
    reportPlaybackEnded(): void {},
    reportPlaybackError(error: string, errorSeverity: number): void {},
    reportPlaybackMetric(metricKey: string, playerState: string): void {},
    reportPlaybackFailed(errorMessage: string, contentInfo?: ConvivaMetadata): void {},
    reportPlaybackRequested(contentInfo: ConvivaMetadata | undefined, initialRequest: Boolean | undefined): void {},
    getVideoAnalytics: () => undefined,
    ConvivaConstants: ConvivaConstants
}

export const ConvivaContext: Context<ConvivaProviderBehavior> = createContext(initialConvivaProviderBehavior)
